<template>
  <v-layout>
    <v-flex>
      <v-card class="totals-box">
        <v-card-title primary-title>
          <div>
            <h3 class="mb-3 font-weight-black title title-form">Enviar email com os seguintes dados</h3>
            <div>
              <p><strong>TO:</strong> {{to}}</p>
              <p><strong>Subject:</strong> FacilitaPay/{{ getPartnerSocialName() }}</p>
              <p>&nbsp;</p>
              <p>Hi!</p>
              <p>&nbsp;</p>
              <p>Following are the credentials for production, as well as the bank account ids.</p>
              <p>Let us know if you have any questions.</p>
              <p>&nbsp;</p>
              <p><strong>URL: </strong>"https://api.facilitapay.com"</p>
              <p><strong>Username: </strong> {{success_response.email}}</p>
              <p><strong>Set password URL: </strong> {{success_response.set_password_url}}</p>
              <p>&nbsp;</p>
              <p><strong>Partner ID:</strong> {{success_response.partner_id}}</p>
              <p>&nbsp;</p>
              <div v-for="facilita_bank_account in success_response.facilita_bank_accounts">
                <p ><strong>facilita_{{getCurrency(facilita_bank_account)}}_account_id:</strong> {{facilita_bank_account.id}} {{getAccountDescription(facilita_bank_account)}}</p>
              </div>
              <p>&nbsp;</p>
              <div v-for="partner_bank_account in success_response.partner_bank_accounts">
                <p ><strong>partner_{{getCurrency(partner_bank_account)}}_account_id:</strong> {{partner_bank_account.id}} {{getAccountDescription(partner_bank_account)}}</p>
              </div>
              <div v-for="internal_bank_account in success_response.internal_bank_accounts">
                <p v-if="separate_internal_bank_account_flows"><strong>partner_{{getCurrency(internal_bank_account)}}_internal_{{getFlowType(internal_bank_account.flow_type)}}_bank_account_id:</strong> {{internal_bank_account.id}}{{getInternationalInternalBankAccountMessage(internal_bank_account)}}</p>
                <p v-else><strong>partner_{{getCurrency(internal_bank_account)}}_internal_bank_account_id:</strong> {{internal_bank_account.id}}</p>
              </div>
            </div>
          </div>
        </v-card-title>
        <v-card-actions>
          <v-btn class="font-weight-black flex-1 secondary-btn-bg-color btn-bg-color text-color-white" @click="backToCreatePartnerScreen">Voltar para tela de cadastro</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  import utils from "./shared/Utils"
  import {currencies}  from "./shared/Currencies"

  export default {
    name: 'AdminPartnerCreatedScreen',
    props: {
      success_response: {
        type: Object
      },
      to: {
        type: String,
        default: ""
      },
      separate_internal_bank_account_flows: {
        type: Boolean,
        default: false
      }
    },
    data(vm) {
      return {}
    },
    methods: {
      backToCreatePartnerScreen(){
        this.$emit('resetForm')
      },
      getCurrency(bank_account) {
        return bank_account.currency.toLowerCase()
      },
      getAccountDescription(bank_account) {
        return "(" + 
                  this.getBankCode(bank_account.bank) + 
                  this.getBankName(bank_account.bank) + 
                  this.getBankBranch(bank_account) + 
                  bank_account.account_number + 
                ")"
      },
      getBankCode(bank) {
        if(bank.swift) return bank.swift + " - "
        else return bank.code + " - "
      },
      getBankName(bank) {
        if(bank.swift){
          if(bank.swift == bank.name) return ""
          else return bank.name + " - "
        } else {
          return bank.name + " - "
        }
      },
      getBankBranch(bank) {
        if(bank.branch_number) return bank.branch_number + " - "
        else return ""
      },
      getFlowType(flow_type) {
        if(flow_type) return flow_type
        else return "cash_in_and_cash_out"
      },
      getInternationalInternalBankAccountMessage(internal_bank_account){
        if(currencies.includes(internal_bank_account.currency)) {
          return " (Branch country: " + this.parseBranchCountry(internal_bank_account.branch_country) + ")"
        }
        return ""
      },
      parseBranchCountry(branch_country) {
        return this.$root.l(utils.parseBranchCountry(branch_country))
      },
      getPartnerSocialName() {
        return this.success_response.internal_bank_accounts[0].partner_owner_name
      }
    },
    metaInfo: {
      title: "Facilita Pay"
    },
  }
</script>

<style scoped>
  .totals-box {
    line-height: 0.3;
  }
  .item {
    padding-top: 10px;
  }
  .sub-item {
    text-align: right;
  }
</style>


// WEBPACK FOOTER //
// src/AdminPartnerCreatedScreen.vue